import { Pagination } from 'types'

export const CITIZEN_RELATION_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 30,
  sort: {
    by: 'unified_person_name',
    order: 'ASC',
  },
}
